import { useTranslation } from 'react-i18next';
import { vendor as vendorApi } from '../../../api';
import { useApi, useAuth } from '../../../hooks';
import { VendorTaxInformationSchema } from '../../../schemas/Vendor';
import { PermissionKey } from '../../../types';
import { EditCardSkeleton } from '../../Card';
import { TaxInformationForm } from './TaxInformationForm';

export const TaxInformationVendor = () => {
  const { hasPermissions } = useAuth();
  const { t } = useTranslation();
  const { data, isLoading, refresh } = useApi(vendorApi.getCurrentTaxInformation, { callImmediately: true });
  const { call } = useApi(vendorApi.updateTaxInformationChangeRequest, { successKey: 'common:success.save' });

  return (
    <EditCardSkeleton
      readOnly={!hasPermissions(PermissionKey.VendorEditFinancial)}
      entity={data}
      isLoading={isLoading}
      title={t('vendor:financials.sections.taxInformation')}
      schema={VendorTaxInformationSchema()}
      onSave={call}
      onConfirm={() => refresh()}
      showModifiedDate
      isChangeRequest
    >
      <TaxInformationForm />
    </EditCardSkeleton>
  );
};
